import React, {useEffect, useState} from "react"
import {useCookies} from "react-cookie"
import {useToasts} from "react-toast-notifications"
import {useLocalStorage} from "react-use"
import {Token} from "../../services/auth"
import LoginContainer from "./LoginContainer"
import Button from "../../components/Button/Button"
import {useNavigate} from "react-router"

export default function LoginSSO() {
	const navigate = useNavigate()
	const {addToast} = useToasts()
	const [workspaceName, setWorkspaceName] = useLocalStorage<string | undefined>("workspaceName", undefined)
	const [, setToken] = useLocalStorage<Token | undefined>("token")
	const [workspace, setWorkspace] = useState(workspaceName ?? "")
	const [cookies, , removeCookie] = useCookies(["login_failure"])

	useEffect(() => {
		try {
			const errorCookie = cookies.login_failure
			if (errorCookie) addToast(errorCookie.reason, {appearance: "error"})
		} finally {
			removeCookie("login_failure")
		}
	}, [])

	const redirectToSSOLogin = (workspace: string) => {
		setToken(undefined)
		setWorkspaceName(workspace)
		window.location.replace(`${process.env.API_URL}/sso/saml/login/${workspace}`)
		return null
	}

	return (
		<LoginContainer>
			<div className="login-container is-flex is-flex-direction-column is-align-self-center is-justify-content-center">
				<span className="label login-title login-sso">Sign in with SSO</span>
				<div className="login-form">
					<div className="field">
						<label className="label">Workspace</label>
						<div className="control">
							<input
								className="input is-medium"
								type="text"
								value={workspace}
								onKeyPress={(e) => {
									e.key === "Enter" ? redirectToSSOLogin(workspace) : null
								}}
								placeholder="Your Workspace name"
								onChange={(e) => setWorkspace(e.target.value)}
								required
								autoComplete="on"
							/>
						</div>
					</div>
					<div className="field login-buttons control is-flex is-align-items-center">
						<div className="alternative-login-buttons">
							<Button
								onClick={() => {
									redirectToSSOLogin(workspace)
								}}
								className="login-button mr-3"
								theme="neutral"
								rounded
							>
								Continue
							</Button>
							<Button
								onClick={() => navigate("/login")}
								className="login-button"
								theme="neutral"
								variant="outline"
								rounded
							>
								Back To Sign in
							</Button>
						</div>
					</div>
				</div>
			</div>
		</LoginContainer>
	)
}
